'use strict';

//region Semantic UI
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/statistic.css');
require('./ModelRow.scss');
//endregion

//region D3
import * as format from 'd3-format';
import * as dateTimeFormatter from 'd3-time-format';
//endregion

import React from 'react';

const ModelRow = (props) => {

  format.formatDefaultLocale(props.locale);
  dateTimeFormatter.timeFormatDefaultLocale(props.timelocale);

  const formatAsPercentage = format.format('.1%');
  const formatAsShortDate = dateTimeFormatter.timeFormat('%x');

  // Failsafe: In case we don't get any real data back (clinton or trump is
  // undefined – usually happens when the FiveThirtyEight spider screws
  // up), don't render anything.
  if (!props.clinton || !props.trump) {
    return null;
  }

  return (
      <div className='ui very fitted vertical segment'>
        <h5 className='ui header'><a
            href={props.source.url} target="_blank">{props.source.name} <i
            className='small external icon'/></a>
          { props.updated ?
              <div className="sub header meta">Stand
                vom {formatAsShortDate(dateTimeFormatter.isoParse(props.updated))}</div> :
              ''}
        </h5>


        <div className='ui mini two statistics'>
          <div className='ui blue statistic'>
            <div className="label">
              <img
                  src='//interaktiv.tagesanzeiger.ch/static/2016/us-elections/clinton.png'
                  alt='' className='ui tiny inline bordered avatar image'/>
            </div>
            <div className='value'>

              {formatAsPercentage(props.clinton)}</div>
          </div>

          <div className='ui red statistic'>
            <div className="label">
              <img
                  src='//interaktiv.tagesanzeiger.ch/static/2016/us-elections/trump.png'
                  alt='' className='ui tiny inline bordered avatar image'/>
            </div>
            <div className='value'>
              {formatAsPercentage(props.trump)}
            </div>
          </div>
        </div>


        <div className='ui small list'>
          { props.children ?
              <div className='item'><i className='info circle icon'/>
                <div className='content'>
                  {props.children}
                </div>
              </div> :
              ''}
        </div>


      </div>

  );
};

ModelRow.defaultProps = {
  source: {
    name: 'Tages-Anzeiger',
    url: 'http://www.tagesanzeiger.ch/'
  },
  clinton: undefined,
  trump: undefined,
  locale: {
    'decimal': ',',
    'thousands': '\u2005',
    'grouping': [3],
    'currency': ['', '\u00a0CHF']
  },
  timelocale: {
    'dateTime': '%A, der %e. %B %Y, %X',
    'date': '%d.%m.%Y',
    'time': '%H:%M:%S',
    'periods': ['vormittags', 'nachmittags'],
    'days': ['Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag'],
    'shortDays': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    'months': ['Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'],
    'shortMonths': ['Jan',
      'Feb',
      'Mrz',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez']
  }
};

ModelRow.propTypes = {
  source: React.PropTypes.shape({
    name: React.PropTypes.text,
    url: React.PropTypes.url
  }).isRequired,
  clinton: React.PropTypes.number,
  trump: React.PropTypes.number,
  locale: React.PropTypes.object,
  timelocale: React.PropTypes.object,
  updated: React.PropTypes.string,
  explanation: React.PropTypes.string
};

export default ModelRow;



/** WEBPACK FOOTER **
 ** ./src/components/modelRow/ModelRow.js
 **/